// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { DashboardOutput } from 'thehive-sdk';
import { useLocalMessage, downloadFile } from '@Helpers/';
import { ICONS } from '@Constants/iconsApp';
import { HeaderButton } from '@Atoms/Buttons';

interface DashboardExportProps {
    dashboard: DashboardOutput;
}

const DashboardExport = ({ dashboard }: DashboardExportProps): ReactElement => {
    const i = useLocalMessage();
    const { _id, title, description, group, status, definition, version } = dashboard;

    const exportDashboard = (): void => {
        const data = {
            _id,
            title,
            description,
            group,
            status,
            definition,
            version,
        };
        const fileName = title.replace(/\s/g, '_');
        const json = JSON.stringify(data);

        downloadFile(fileName + '.json', json, 'application/json');
    };

    return (
        <HeaderButton label={i('dashboard.item.export')} onClick={exportDashboard} icon={<ICONS.ExportFileIcon />} />
    );
};

export default DashboardExport;
